module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['modal', _vm.effect],
    attrs: {
      "role": "dialog"
    },
    on: {
      "click": function($event) {
        _vm.backdrop && _vm.action(false, 1)
      },
      "transitionend": function($event) {
        _vm.transition = false
      }
    }
  }, [_c('div', {
    class: ['modal-dialog', {
      'modal-lg': _vm.large,
      'modal-sm': _vm.small
    }],
    style: ({
      width: _vm.optionalWidth
    }),
    attrs: {
      "role": "document"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.action(null)
      }
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._t("modal-header", [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.action(false, 2)
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2)])]), _vm._v(" "), _vm._t("modal-body", [_c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _vm._t("modal-footer", [_c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.action(false, 3)
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.action(true, 4)
      }
    }
  }, [_vm._v(_vm._s(_vm.okText))])])])], 2)])])
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4041e763", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4041e763!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Modal.vue
// module id = 127
// module chunks = 0